import React from "react";
import { NavLink } from "react-router-dom";
// @ts-ignore
import "./MobileTabBar.css";

export default function MobileTabBar(): JSX.Element {
  return (
    <nav className="gs-tabbar" aria-label="Quick navigation">
      <NavLink className="gs-tabbar-item" to="/" end title="Home">
        <i className="fas fa-house" aria-hidden="true"></i>
        <span>Home</span>
      </NavLink>
      <NavLink className="gs-tabbar-item" to="/services" title="Our Services">
        <i className="fas fa-concierge-bell" aria-hidden="true"></i>
        <span>Services</span>
      </NavLink>
      <NavLink className="gs-tabbar-item gs-tabbar-book" to="/get-a-quote" title="Get a Quote">
        <span className="gs-tabbar-book-circle">
          <i className="fas fa-calendar-check" aria-hidden="true"></i>
        </span>
        <span>Book</span>
      </NavLink>
      <NavLink className="gs-tabbar-item" to="/fleet" title="Our Fleet">
        <i className="fas fa-car" aria-hidden="true"></i>
        <span>Fleet</span>
      </NavLink>
      <NavLink className="gs-tabbar-item" to="/contact" title="Contact Us">
        <i className="fas fa-phone" aria-hidden="true"></i>
        <span>Contact</span>
      </NavLink>
    </nav>
  );
}
